// extracted by mini-css-extract-plugin
export default {"noSpinner":"input-module__noSpinner__wLy5y"};